import React from "react";
import { FileText } from "lucide-react";
import { ADEMPIMENTI } from "../data/content";
import Reveal from "../components/site/Reveal";

export default function AdempimentiPage() {
  return (
    <div className="pt-20">
      <section data-testid="adempimenti-section" className="bg-white py-20 md:py-28 min-h-[70vh]">
        <div className="mx-auto max-w-[1100px] px-4 md:px-8 lg:px-12">
          <Reveal>
            <p className="font-sub uppercase tracking-[0.3em] text-court font-bold text-sm mb-4">
              Trasparenza
            </p>
            <h1 className="font-heading uppercase leading-[0.9] text-navy text-4xl md:text-6xl tracking-tight">
              Adempimenti L. 124/2017
            </h1>
          </Reveal>

          <Reveal delay={0.05}>
            <p className="mt-8 font-body text-navy/75 text-base md:text-lg leading-relaxed border-l-4 border-court pl-6 max-w-3xl">
              {ADEMPIMENTI.intro}
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-12 border-4 border-navy" data-testid="adempimenti-table">
              <div className="hidden md:grid grid-cols-12 bg-navy text-white font-sub uppercase tracking-wider text-xs">
                <div className="col-span-3 p-4">Periodo</div>
                <div className="col-span-4 p-4">Ente erogante</div>
                <div className="col-span-3 p-4">Causale</div>
                <div className="col-span-2 p-4 text-right">Importo</div>
              </div>
              {ADEMPIMENTI.entries.map((e, i) => (
                <div
                  key={i}
                  data-testid={`adempimento-${i}`}
                  className={`grid grid-cols-1 md:grid-cols-12 border-t-2 border-navy/15 ${
                    i % 2 ? "bg-cream" : "bg-white"
                  }`}
                >
                  <div className="md:col-span-3 px-4 pt-4 md:py-4 font-sub uppercase text-sm font-bold text-court">
                    {e.period}
                  </div>
                  <div className="md:col-span-4 px-4 py-1 md:py-4 font-body text-navy">{e.entity}</div>
                  <div className="md:col-span-3 px-4 py-1 md:py-4 font-body text-navy/70">{e.causale}</div>
                  <div className="md:col-span-2 px-4 pb-4 md:py-4 font-heading text-navy text-xl md:text-right">
                    {e.amount}
                  </div>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="mt-8 flex items-center gap-3 text-navy/50">
              <FileText size={18} />
              <span className="font-body text-sm">
                Informazioni pubblicate ai sensi dell&apos;art. 1, commi 125-129, della Legge 124/2017.
              </span>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
